import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// Import Global Components
import Main from '../../components/Main';
import SectionOne from './components/SectionOne';
import VirtualCardInfo from './components/VirtualCardInfo';
// Import Translations
import { activatedEn } from '../../i18n/activated';

const Activated = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // Pull CardDetails from Location State
  const virtualCardDetails = location.state?.virtualCardDetails;

  // If no card details, redirect or show error
  if (!virtualCardDetails) {
    return (
      <Main
        title={activatedEn['activated-main-title']}
        page="activated"
        error="No card details found. Please complete the activation process first."
      />
    );
  }

  return (
    <Main
      title={activatedEn['activated-main-title']}
      page="activated"
      sectionOne={(
        <SectionOne
          number={virtualCardDetails.card_number}
          name={virtualCardDetails.cardholder_name}
          expiry={virtualCardDetails.expiry_date}
          cardSecurityCode={virtualCardDetails.card_security_code}
          address={virtualCardDetails.address}
          iframeUrl={virtualCardDetails.iframe_url}
        />
      )}
      sectionTwo={(
        <VirtualCardInfo registerLink={virtualCardDetails.register_card_link} cardholderFeeDisclosureUrl={virtualCardDetails?.cardholder_fee_disclosure_url || ''} />
      )}
      navigate={navigate}
    />
  );
};

export default Activated;